'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useEffect, useState } from 'react'

// walrus
import Text from '@components/kit/text'
import Box from '@components/kit/box'
import Pressable from '@components/kit/pressable'
import Loading from '@components/kit/loading'
import { useNavigate } from 'react-router-dom'
import { CompanyListItem, useMembersStore } from '@store/Members'

/* -----------------------------------------------------------------------------
 * ByCompany
 * -------------------------------------------------------------------------- */

function ByCompany() {
  const navigate = useNavigate()
  const { fetchCompaniesList } = useMembersStore.getState()
  const [companies, setCompanies] = useState<CompanyListItem[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetchCompaniesList()
      .then(setCompanies)
      .finally(() => setIsLoading(false))
  }, [])

  if (isLoading) {
    return (
      <Box flex='1 1 auto' alignItems='center' justifyContent='center' py='40'>
        <Loading />
      </Box>
    )
  }

  return (
    <Box mt='16'>
      {companies.length === 0 ? (
        <Box
          flex='1 1 auto'
          alignItems='center'
          justifyContent='center'
          py='40'
        >
          <Text fontSize={13} textColor='purple'>
            No companies found
          </Text>
        </Box>
      ) : (
        companies.map(item => (
          <Box key={item.company_id} mb='16' gap='08'>
            <Pressable
              onPress={() => navigate(`/members/company/${item.company_id}`)}
            >
              <Text font='text.14.medium' textColor='walrusBlue200'>
                {item.company_name} ({item.qty})
              </Text>
            </Pressable>
          </Box>
        ))
      )}
    </Box>
  )
}

export default ByCompany
